import { Tide, WeatherConditions, type Nullable } from "@/models"
import { SARLogHttpService } from "@/services/httpService"

export class WeatherService extends SARLogHttpService {
	constructor() {
		super("/api/conditions")
	}

	async getCurrentConditions(): Promise<Nullable<WeatherConditions>> {
		return await this.returning(WeatherConditions.nullable()).get("weather")
	}

	async getCurrentTide(): Promise<Nullable<Tide>> {
		return await this.returning(Tide.nullable()).get("tide")
	}
}
